export default{
  methods:{
    pollClicked(title,time) {
        if (this.initialPrefs.sendEventsToDataLayer) {
          this.$gtag.event('videoEvent', {
            'videoCategory': 'Springer Healthcare Interactive Video',
            'videoAction': 'Video Interaction: click on the poll',
            'videoId': this.initialPrefs.videoID,
            'videoName': this.initialPrefs.projectName,
            'videoLive': 'false',
            'videoSection': title
          });
        }
      this.$root.$emit('seekVideo',time) 
      this.$root.$emit('playVideo') 
    },
  }
}